import * as React from "react"
import {Loader} from "semantic-ui-react"
import {Booker} from "../graphql/queries"
import {GraphQL} from "../graphql"

// This is the outermost wrapper of the app and it ensures we have a stable session id (on the
// backend and in our cookie) by making a single synchronous request to the backend before rendering
// the app proper.  The endpoint we fetch doesn't really matter because as a side effect of fetching
// *anything* synchronously we achieve our goal.
//
// If you don't do this: when a new user (ie. without a cookie) does an initial load of the site a
// flurry of async graphql requests will be made to the backend and *none of these will contain a
// request cookie* and thus each of them we be assigned a fresh session id by the backend thus *the
// last one returned* will determine the actual, stable, session id.  This indeterminacy makes nonce
// use for authentication unreliable, among other things.

function WithApollo(props: {children: JSX.Element}) {
  return (
    <GraphQL.Query
      query={Booker}
      variables={{}}
      render={({data}) => {
        if (data !== null) {
          return props.children
        }
        return <Loader active />
      }}
    />
  )
}

export {WithApollo as InitializeSession}



// WEBPACK FOOTER //
// ./src/components/InitializeSession.tsx